var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-light"},[_vm._m(0),_c('RouterLink',{staticClass:"text-decoration-none",attrs:{"to":{ name: '' }}},[_c('FontAwesomeIcon',{attrs:{"icon":['fas', 'arrow-trend-up'],"fixed-width":""}}),_vm._v(" All Metrics ")],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5"},[_c('div',{staticClass:"py-4"},[_vm._v("At-a-glance metrics")])])
}]

export { render, staticRenderFns }